<script setup>
import { toRefs } from "vue";

const props = defineProps({
  tableauInformation: {
    type: Object,
    default: {},
  },
});

const { tableauInformation } = toRefs(props);
</script>

<template>
  <table
    class="m-4 w-full block border-b border-solid border-gray-200 sm:table sm:p-10"
  >
    <thead class="hidden md:table-header-group">
      <tr class="border-b border-solid border-gray-200">
        <th
          v-for="header of tableauInformation?.columns ?? []"
          :id="header"
          class="items-center py-4 pr-3 text-left text-sm text-gray-900 first:pl-2"
        >
          <div>{{ header }}</div>
        </th>
      </tr>
    </thead>
    <tbody class="block sm:table-row-group">
      <tr
        v-for="(line, idx) of tableauInformation?.data ?? []"
        :id="idx"
        class="flex flex-col md:table-row"
      >
        <td
          v-for="(item, idxi) of line || []"
          :id="`${idx}-${idxi}`"
          class="py-5"
        >
          {{ item ?? "" }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
